import { render, staticRenderFns } from "./InputImageBase.vue?vue&type=template&id=2cbf852f&scoped=true&"
import script from "./InputImageBase.vue?vue&type=script&lang=js&"
export * from "./InputImageBase.vue?vue&type=script&lang=js&"
import style0 from "./InputImageBase.vue?vue&type=style&index=0&id=2cbf852f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf852f",
  null
  
)

export default component.exports